import { createContext } from "react";

const PrestamoContext = createContext();

export default PrestamoContext;